import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Studio\PhotoUploadController::store
* @see app/Http/Controllers/Studio/PhotoUploadController.php:35
* @route '/studio/galerie/{gallery}/fotky'
*/
export const store = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/studio/galerie/{gallery}/fotky',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Studio\PhotoUploadController::store
* @see app/Http/Controllers/Studio/PhotoUploadController.php:35
* @route '/studio/galerie/{gallery}/fotky'
*/
store.url = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { gallery: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { gallery: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            gallery: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        gallery: typeof args.gallery === 'object'
        ? args.gallery.slug
        : args.gallery,
    }

    return store.definition.url
            .replace('{gallery}', parsedArgs.gallery.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Studio\PhotoUploadController::store
* @see app/Http/Controllers/Studio/PhotoUploadController.php:35
* @route '/studio/galerie/{gallery}/fotky'
*/
store.post = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Studio\PhotoUploadController::store
* @see app/Http/Controllers/Studio/PhotoUploadController.php:35
* @route '/studio/galerie/{gallery}/fotky'
*/
const storeForm = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Studio\PhotoUploadController::store
* @see app/Http/Controllers/Studio/PhotoUploadController.php:35
* @route '/studio/galerie/{gallery}/fotky'
*/
storeForm.post = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Studio\PhotoUploadController::destroy
* @see app/Http/Controllers/Studio/PhotoUploadController.php:144
* @route '/studio/galerie/{gallery}/fotky/{photo}'
*/
export const destroy = (args: { gallery: string | { slug: string }, photo: number | { id: number } } | [gallery: string | { slug: string }, photo: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/studio/galerie/{gallery}/fotky/{photo}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Studio\PhotoUploadController::destroy
* @see app/Http/Controllers/Studio/PhotoUploadController.php:144
* @route '/studio/galerie/{gallery}/fotky/{photo}'
*/
destroy.url = (args: { gallery: string | { slug: string }, photo: number | { id: number } } | [gallery: string | { slug: string }, photo: number | { id: number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            gallery: args[0],
            photo: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        gallery: typeof args.gallery === 'object'
        ? args.gallery.slug
        : args.gallery,
        photo: typeof args.photo === 'object'
        ? args.photo.id
        : args.photo,
    }

    return destroy.definition.url
            .replace('{gallery}', parsedArgs.gallery.toString())
            .replace('{photo}', parsedArgs.photo.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Studio\PhotoUploadController::destroy
* @see app/Http/Controllers/Studio/PhotoUploadController.php:144
* @route '/studio/galerie/{gallery}/fotky/{photo}'
*/
destroy.delete = (args: { gallery: string | { slug: string }, photo: number | { id: number } } | [gallery: string | { slug: string }, photo: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Studio\PhotoUploadController::destroy
* @see app/Http/Controllers/Studio/PhotoUploadController.php:144
* @route '/studio/galerie/{gallery}/fotky/{photo}'
*/
const destroyForm = (args: { gallery: string | { slug: string }, photo: number | { id: number } } | [gallery: string | { slug: string }, photo: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Studio\PhotoUploadController::destroy
* @see app/Http/Controllers/Studio/PhotoUploadController.php:144
* @route '/studio/galerie/{gallery}/fotky/{photo}'
*/
destroyForm.delete = (args: { gallery: string | { slug: string }, photo: number | { id: number } } | [gallery: string | { slug: string }, photo: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\Studio\PhotoUploadController::retry
* @see app/Http/Controllers/Studio/PhotoUploadController.php:173
* @route '/studio/galerie/{gallery}/fotky/{photo}/zkusit-znovu'
*/
export const retry = (args: { gallery: string | { slug: string }, photo: number | { id: number } } | [gallery: string | { slug: string }, photo: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: retry.url(args, options),
    method: 'post',
})

retry.definition = {
    methods: ["post"],
    url: '/studio/galerie/{gallery}/fotky/{photo}/zkusit-znovu',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Studio\PhotoUploadController::retry
* @see app/Http/Controllers/Studio/PhotoUploadController.php:173
* @route '/studio/galerie/{gallery}/fotky/{photo}/zkusit-znovu'
*/
retry.url = (args: { gallery: string | { slug: string }, photo: number | { id: number } } | [gallery: string | { slug: string }, photo: number | { id: number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            gallery: args[0],
            photo: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        gallery: typeof args.gallery === 'object'
        ? args.gallery.slug
        : args.gallery,
        photo: typeof args.photo === 'object'
        ? args.photo.id
        : args.photo,
    }

    return retry.definition.url
            .replace('{gallery}', parsedArgs.gallery.toString())
            .replace('{photo}', parsedArgs.photo.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Studio\PhotoUploadController::retry
* @see app/Http/Controllers/Studio/PhotoUploadController.php:173
* @route '/studio/galerie/{gallery}/fotky/{photo}/zkusit-znovu'
*/
retry.post = (args: { gallery: string | { slug: string }, photo: number | { id: number } } | [gallery: string | { slug: string }, photo: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: retry.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Studio\PhotoUploadController::retry
* @see app/Http/Controllers/Studio/PhotoUploadController.php:173
* @route '/studio/galerie/{gallery}/fotky/{photo}/zkusit-znovu'
*/
const retryForm = (args: { gallery: string | { slug: string }, photo: number | { id: number } } | [gallery: string | { slug: string }, photo: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: retry.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Studio\PhotoUploadController::retry
* @see app/Http/Controllers/Studio/PhotoUploadController.php:173
* @route '/studio/galerie/{gallery}/fotky/{photo}/zkusit-znovu'
*/
retryForm.post = (args: { gallery: string | { slug: string }, photo: number | { id: number } } | [gallery: string | { slug: string }, photo: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: retry.url(args, options),
    method: 'post',
})

retry.form = retryForm

const photos = {
    store: Object.assign(store, store),
    destroy: Object.assign(destroy, destroy),
    retry: Object.assign(retry, retry),
}

export default photos